import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import logoGold from '@/assets/logo-gold-white.png';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-primary">
      <div className="section-padding py-20 lg:py-28">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          <div>
            <img
              src={logoGold}
              alt="Sivota Royal Luxury Retreat"
              className="h-16 lg:h-20 w-auto mb-6"
              loading="lazy"
              width={160}
              height={80}
            />
            <p className="font-sans text-sm text-primary-foreground/80 leading-relaxed max-w-xs">
              {t('footerDesc')}
            </p>
          </div>

          <div>
            <h2 className="text-luxury mb-6 text-primary-foreground/70">{t('quickLinks')}</h2>
            <nav aria-label="Footer navigation">
              <div className="flex flex-col gap-3">
                {[
                  { key: 'about', path: '/about' },
                  { key: 'apartments', path: '/apartments' },
                  { key: 'destinations', path: '/destinations' },
                  { key: 'reviews', path: '/reviews' },
                  { key: 'booking', path: '/booking' },
                  { key: 'contact', path: '/contact' },
                ].map(l => (
                  <Link key={l.key} to={l.path} className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                    {t(l.key)}
                  </Link>
                ))}
              </div>
            </nav>
          </div>

          <div>
            <h2 className="text-luxury mb-6 text-primary-foreground/70">{t('contact')}</h2>
            <div className="flex flex-col gap-4 text-sm text-primary-foreground/80">
              <div className="flex items-center gap-3">
                <MapPin size={16} aria-hidden="true" />
                <span>{t('sivotaGreece')}</span>
              </div>
              <a href="mailto:sivotaroyal@gmail.com" className="flex items-center gap-3 hover:text-primary-foreground transition-colors">
                <Mail size={16} aria-hidden="true" />
                <span>sivotaroyal@gmail.com</span>
              </a>
              <a href="tel:+306948561312" className="flex items-center gap-3 hover:text-primary-foreground transition-colors">
                <Phone size={16} aria-hidden="true" />
                <span>+30 694 856 1312</span>
              </a>
            </div>
          </div>

          <div>
            <h2 className="text-luxury mb-6 text-primary-foreground/70">{t('bookNow')}</h2>
            <Link
              to="/booking"
              className="inline-flex items-center gap-2 text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors"
            >
              {t('checkAvailability')}
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-primary-foreground/10 text-center">
          <p className="text-xs text-primary-foreground/60">COPYRIGHT © {new Date().getFullYear()} — SIVOTAROYAL.COM ALL RIGHTS RESERVED</p>
        </div>
      </div>
    </footer>
  );
}
